import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, openFile, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './blog.reducer';

export const BlogDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const blogEntity = useAppSelector(state => state.blog.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="blogDetailsHeading">
          <Translate contentKey="fitengineerBackendV2App.blog.detail.title">Blog</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{blogEntity.id}</dd>
          <dt>
            <span id="blogTitle">
              <Translate contentKey="fitengineerBackendV2App.blog.blogTitle">Blog Title</Translate>
            </span>
          </dt>
          <dd>{blogEntity.blogTitle}</dd>
          <dt>
            <span id="blogContent">
              <Translate contentKey="fitengineerBackendV2App.blog.blogContent">Blog Content</Translate>
            </span>
          </dt>
          <dd>{blogEntity.blogContent}</dd>
          <dt>
            <span id="image1">
              <Translate contentKey="fitengineerBackendV2App.blog.image1">Image 1</Translate>
            </span>
          </dt>
          <dd>
            {blogEntity.image1 ? (
              <div>
                {blogEntity.image1ContentType ? (
                  <a onClick={openFile(blogEntity.image1ContentType, blogEntity.image1)}>
                    <img src={`data:${blogEntity.image1ContentType};base64,${blogEntity.image1}`} style={{ maxHeight: '30px' }} />
                  </a>
                ) : null}
                <span>
                  {blogEntity.image1ContentType}, {byteSize(blogEntity.image1)}
                </span>
              </div>
            ) : null}
          </dd>
          <dt>
            <span id="image2">
              <Translate contentKey="fitengineerBackendV2App.blog.image2">Image 2</Translate>
            </span>
          </dt>
          <dd>
            {blogEntity.image2 ? (
              <div>
                {blogEntity.image2ContentType ? (
                  <a onClick={openFile(blogEntity.image2ContentType, blogEntity.image2)}>
                    <img src={`data:${blogEntity.image2ContentType};base64,${blogEntity.image2}`} style={{ maxHeight: '30px' }} />
                  </a>
                ) : null}
                <span>
                  {blogEntity.image2ContentType}, {byteSize(blogEntity.image2)}
                </span>
              </div>
            ) : null}
          </dd>
          <dt>
            <span id="image3">
              <Translate contentKey="fitengineerBackendV2App.blog.image3">Image 3</Translate>
            </span>
          </dt>
          <dd>
            {blogEntity.image3 ? (
              <div>
                {blogEntity.image3ContentType ? (
                  <a onClick={openFile(blogEntity.image3ContentType, blogEntity.image3)}>
                    <img src={`data:${blogEntity.image3ContentType};base64,${blogEntity.image3}`} style={{ maxHeight: '30px' }} />
                  </a>
                ) : null}
                <span>
                  {blogEntity.image3ContentType}, {byteSize(blogEntity.image3)}
                </span>
              </div>
            ) : null}
          </dd>
        </dl>
        <Button tag={Link} to="/blog" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/blog/${blogEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BlogDetail;
